import type { NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class ThreeDView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setCameraLocked(locked: boolean) {
    this.graph.wasmEdit((wasm) => wasm.setCameraLocked(this.nodeId, locked));
  }
}
